import { useIdentityStore } from '../lib/store';

export const useCurrentCompany = () => {
	return useIdentityStore((state) => state.company);
};
